import { gql } from "@apollo/client";

export const FETCH_FSI_ORDERS = gql`
  query FETCH_FSI_ORDERS($offset: Int, $q: String) {
    fsiOrders(offset: $offset, limit: 30, q: $q) {
      total
      results {
        id
        orderId
        orderNumber
        createdAt
        data
        status
        message
      }
    }
  }
`;

export const FETCH_FSI_ORDER_DETAIL = gql`
  query FETCH_FSI_ORDER_DETAIL($id: ID!) {
    fsiOrder(id: $id)
  }
`;

export const FSI_CREATE_ORDERS = gql`
  mutation FSI_CREATE_ORDERS($orders: String!) {
    fsiCreateOrders(orders: $orders) {
      orders {
        id
        orderNumber
        status
      }
    }
  }
`;

export const FETCH_ODOO_ORDERS_FOR_FSI = gql`
  query FETCH_ODOO_ORDERS_FOR_FSI($fsiOrderDate: String) {
    odooSaleOrders(instance: "INC", useType: "FSI", fsiOrderDate: $fsiOrderDate)
  }
`;
